import { getPreviousDate, getMonth, getQuarter, getYear } from "@ui-seeker/utils";

import {DATE_PERIODS} from "@constants";
import { currentPeriod } from "@signals"


const currentDay = new Date().getDay()
const currentMonth = getMonth()
const currentYear = getYear()
const currentQuarter = getQuarter()

const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1
const lastQuarterMonth = lastQuarter * 3
const lastQuarterYear = currentQuarter === 1 ? currentYear - 1 : currentYear

export const dipRangeDates = [{
	label: 'Yesterday',
	value: [getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.YESTERDAY
}, {
	label: 'Last 7 Days',
	value: [getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_7_DAYS
}, {
	label: 'Last 30 Days',
	value: [getPreviousDate({ days: 30 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_30_DAYS
}, {
	label: 'Last 60 Days',
	value: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_60_DAYS
}, {
	label: 'Last 90 Days',
	value: [getPreviousDate({ days: 90 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_90_DAYS
}, {
	label: 'Last Month',
	value: [
        getPreviousDate({ months: 1 }, new Date(currentYear, currentMonth - 1, 1)),
        getPreviousDate({ days: 1 },  new Date(currentYear, currentMonth - 1, 1))
    ],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_MONTH
}, {
	label: 'Last Quarter',
	value: [
        new Date(lastQuarterYear, lastQuarterMonth - 3, 1),
        new Date(lastQuarterYear, lastQuarterMonth, 0)
    ],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_QUARTER
}, {
	label: 'Year to Date',
	value: [
        new Date(currentYear, 0, 1),
        currentDay === 1 && currentMonth === 0 ? new Date(currentYear, 0, 1) : getPreviousDate({ days: 1 })
    ],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.YEAR_TO_DATE
}, {
	label: 'Last Year',
	value: [
        getPreviousDate({ years: 1 }, new Date(currentYear, 0, 1)),
        getPreviousDate({ years: 1 }, new Date(currentYear, 12, 0))
    ],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_YEAR
}]